import { render, staticRenderFns } from "./vResidentRequestCard.vue?vue&type=template&id=fe3f3fa2&scoped=true"
import script from "./vResidentRequestCard.vue?vue&type=script&lang=js"
export * from "./vResidentRequestCard.vue?vue&type=script&lang=js"
import style0 from "./vResidentRequestCard.vue?vue&type=style&index=0&id=fe3f3fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3f3fa2",
  null
  
)

export default component.exports